import {LangKeyType} from '../../../../provider/locale/translation/type';
import {CommentsLayoutType, ExportReportModeEnum} from '../../../../service/reviews/reviews-report';

export type ReviewsDownloadReportPopupItemType = {
    mode: ExportReportModeEnum;
    header: LangKeyType;
    description: LangKeyType;
    placeholder: LangKeyType;
};

export const enum ReviewsReportFormEnum {
    Mode = 'mode',
    Name = 'name',
    WithReviewsSummary = 'withReviewsSummary',
    WithTagsStat = 'withTagsStat',
    AdditionalUserEmails = 'additionalUserEmails',
    CommentsLayout = 'commentsLayout',
}

export type ReviewsReportFormType = {
    [ReviewsReportFormEnum.Name]: string;
    [ReviewsReportFormEnum.WithReviewsSummary]: boolean;
    [ReviewsReportFormEnum.WithTagsStat]: boolean;
    [ReviewsReportFormEnum.AdditionalUserEmails]?: string;
    [ReviewsReportFormEnum.CommentsLayout]: CommentsLayoutType;
};
